import './browser-compat';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/theme.css';
import './styles/geometry-bg.css';
import './styles/app.css';
import './styles/admin.css';
import './styles/folders.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root 不存在');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
